
import { reactive, ref, toRaw } from 'vue';
import { Vue, Options } from 'vue-class-component';

@Options({
  props:{
    tile: {type: Object},
    index: {type: Number},
    errors: {type: Object}
  },
  setup(){
    const formRef = ref();

    const formState = reactive({
      quantity: undefined
    });

    return {
      formRef,
      formState
    }
  },
  methods: {
    saveFootage(e){
      const value = parseFloat(e.target.value);
      this.$store.state.selectedTiles[this.index].quantity = value
      const tiles = this.$store.state.selectedTiles;
    },
    async validateArea(r, v) {
      if (parseFloat(v) > 0) {
        return Promise.resolve();
      } else if(v) {
        return Promise.reject('Vrednost mora biti večja od 0!');
      } else {
        return Promise.reject('Polje je obvezno!');
      }
    }
  }
})
export default class SurfaceInput extends Vue {

}
